export interface AuditTrailsActivityLogDataModel {
  time: string;
  log_name: string;
  description: string;
  causer_type: string;
  created_at: string;
  causer: {
    email: string;
    name: string;
    username: string;
  }
  empty?: boolean;
}
export interface AuditTrailsSystemLogDataModel {
  level: string;
  level_class: string;
  context: string;
  date: string;
  content: string;
  stack: string;
  text: string;
  empty?: boolean;
}
export interface AuditTrailsSystemLogFileModel {
  name: string;
  hash: string;
}

export interface ConfigureAuditTrailsModel {
  activityLogs: {
    main: {
      data: AuditTrailsActivityLogDataModel[];
      total: number;
    };
  };
  systemLogs: {
    main: {
      data: AuditTrailsSystemLogDataModel[];
      total: number;
    };
  };
  systemLogsFile: {
    main: {
      data: AuditTrailsSystemLogFileModel[];
      total: number;
    };
  }
}

export enum ConfigureAuditTrailsActionType {
  GetActivityLogsMain = "⌘➝Configure➝Audit Trails➝GetActivityLogsMain",
  GetSystemLogsMain = "⌘➝Configure➝Audit Trails➝GetSystemLogsMain",
  GetSystemLogFiles = "⌘➝Configure➝Audit Trails➝GetSystemLogFiles",
}

export type ConfigureAuditTrailsAction = {
  data: {
    data: AuditTrailsActivityLogDataModel[];
    total: number;
  };
  type: ConfigureAuditTrailsActionType.GetActivityLogsMain;
} | {
  data: {
    data: AuditTrailsSystemLogDataModel[];
    total: number;
  };
  type: ConfigureAuditTrailsActionType.GetSystemLogsMain;
} | {
  data: {
    data: AuditTrailsSystemLogFileModel[];
    total: number;
  };
  type: ConfigureAuditTrailsActionType.GetSystemLogFiles;
};
